import { MedplumClient } from "@medplum/core";
import { Encounter } from "@medplum/fhirtypes";

import { Questionnaires } from "@/fhir/enums/questionnaires";

import {
  QuestionnaireURLBasedOnEncounterType,
  questionnaireURLBasedOnEncounterType,
} from "../constants/questionnaire";

export const fetchEncounterQuestionnaire = async (
  medplum: MedplumClient,
  encounter: Encounter,
  query?: Record<string, string | number | boolean | undefined>,
) => {
  const url =
    questionnaireURLBasedOnEncounterType[
      (encounter.serviceType?.coding?.[0]?.display as QuestionnaireURLBasedOnEncounterType) ?? ""
    ];

  if (!url) return;

  const questionnaire = await medplum.searchOne("Questionnaire", {
    url,
    status: "active",
    _sort: "-_lastUpdated",
    ...(query ?? {}),
  });

  return questionnaire;
};

export const fetchCptCodeQuestionnaire = async (medplum: MedplumClient) => {
  const questionnaire = await medplum.searchOne("Questionnaire", {
    url: Questionnaires.CPTCodes,
    _sort: "-_lastUpdated",
  });

  return questionnaire;
};
